import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface PaymentSettings {
  qrCodeData: string; // The payment QR code data (e.g., bank account, e-wallet info)
  qrCodeImage?: string; // Base64 encoded QR code image (if user uploads an image)
  includeInReceipt: boolean; // Whether to include QR code in printed receipts
  qrCodeLabel?: string; // Optional label for the QR code (e.g., "Scan to Pay")
}

interface PaymentSettingsState {
  settings: PaymentSettings;
  setSettings: (newSettings: Partial<PaymentSettings>) => void;
  resetToDefault: () => void;
}

const defaultSettings: PaymentSettings = {
  qrCodeData: '',
  qrCodeImage: undefined,
  includeInReceipt: false,
  qrCodeLabel: 'Scan to Pay',
};

export const usePaymentSettingsStore = create<PaymentSettingsState>()(
  persist(
    (set: any, get: any) => ({
      settings: defaultSettings,
      setSettings: (newSettings: Partial<PaymentSettings>) =>
        set((state: PaymentSettingsState) => ({
          settings: { ...state.settings, ...newSettings },
        })),
      resetToDefault: () =>
        set(() => ({
          settings: defaultSettings,
        })),
    }),
    {
      name: 'payment-settings',
    }
  )
);







